import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import ReportBuilder from "components/menu/master-files/report-builder/list";

const ReportBuilderRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={ReportBuilder}
            />
        </Switch>
    </div>
);

export default connect()(ReportBuilderRouter);
